/**
 * Indicate that we want to save registration refund informations form values into store / local storage
 */
export const SAVE_REGISTRATION_REFUND_INFORMATIONS = "SAVE_REGISTRATION_REFUND_INFORMATIONS"

/**
 * Indicate that we want to clear registration refund informations form values into store / local storage
 */
export const CLEAR_REGISTRATION_REFUND_INFORMATIONS = "CLEAR_REGISTRATION_REFUND_INFORMATIONS"
